import { combineReducers } from 'redux'

import { alert } from 'srcReact/Alert'
import { footer } from 'srcReact/Footer'
import { common } from 'srcReact/components'
import { login } from 'srcReact/LoginPage'
import { dashboardDetail } from 'srcReact/Dashboard/reducer'
import { organization } from 'srcReact/OrganizationPage'
import { workplace } from 'srcReact/WorkplacePage'
import { profile } from 'srcReact/ProfilePage'
import { group, createUpdateGroup } from 'srcReact/GroupPage'
import { subscription } from 'srcReact/SubscriptionPage'
import { messenger } from 'srcReact/MessengerPage/reducer'
import { authentication } from 'srcReact/redux/reducer/authentication'
import { settings } from 'srcReact/Settings/reducer'
import { myhome } from 'srcReact/MyHomePage/reducer'
import { discover } from 'srcReact/DiscoverPage/reducer'
import { myProfile } from 'srcReact/MyProfile/reducer'
import { calendarEvents } from 'srcReact/CalendarPage/reducer'
import { organizationSettings } from 'srcReact/OrganizationSettingsPage/reducer'
import { groupHome } from 'srcReact/GroupHomePage/reducer'
import { mixr } from 'srcReact/Mixr/reducer'
import { feedHome } from 'srcReact/FeedPage/reducer'
import { globalSearch } from 'srcReact/SearchPage/reducer'
import { sideBar } from 'srcReact/components/common2/Navigation/SideBarMain/reducer'
import { shareMedia } from '../components/common2/ShareMedia/reducer'
import { joinGroup } from 'srcReact/components/popinsContent/JoinGroup/reducer'
import { lightProfile } from 'srcReact/components/common2/LightProfileModal/reducer'
import { media } from 'srcReact/components/common2/MediaTabContent/reducer'
import { moderationReport } from 'srcReact/ModerationReportPage/reducer'
import { calWidget } from 'srcReact/components/Widgets/Calendar/reducer'
import { commonNewsfeed } from 'srcReact/components/common2/FeedsTabContent/reducer'
import { rsvp } from 'srcReact/components/common2/RSVP/reducer'
import { workplaceSettings } from 'srcReact/WorkplaceSettingsPage/reducer'
import { integration } from 'srcReact/Pages/IntegrationSettings/reducer'
import { invite } from 'srcReact/components/common2/InviteWPMembers/reducer'
import { support } from 'srcReact/Pages/Support/reducer'

const rootReducer = combineReducers({
  alert,
  authentication,
  common,
  footer,
  login,
  dashboardDetail,
  organization,
  workplace,
  profile,
  group,
  createUpdateGroup,
  subscription,
  messenger,
  settings,
  myhome,
  discover,
  myProfile,
  groupHome,
  mixr,
  feedHome,
  sideBar,
  calendarEvents,
  shareMedia,
  joinGroup,
  lightProfile,
  globalSearch,
  media,
  organizationSettings,
  moderationReport,
  calWidget,
  commonNewsfeed,
  rsvp,
  workplaceSettings,
  integration,
  invite,
  support
})

export default rootReducer
